class EventBus {
  constructor() {
    this.listeners = {};
  }

  // Subscribe to an event
  on(event, listener) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(listener);
  }

  // Emit an event
  emit(event, payload) {
    if (this.listeners[event]) {
      this.listeners[event].forEach((listener) => listener(payload));
    }
  }

  // Unsubscribe from an event
  off(event, listener) {
    if (!this.listeners[event]) return;

    this.listeners[event] = this.listeners[event].filter((l) => l !== listener);
  }
}

const eventBus = new EventBus();
export default eventBus;
